import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useRules } from '../../lib/rules';
import { parseTags, normaliseKey } from '../../lib/string';
import getFormulationIngredients from "../../lib/getFormulationIngredients";

const defaultInfo = {
  title: null,
  description: 'Click on a goal above and learn more about it here.',
};

const FormulationScreen = ({ state, step, onNext }) => {
  const { heading, subHeading = null, autoSubmit = true, field } = step;
  const { name = heading, component: FieldComponent, rules, ...props } = field;

  const ingredientGroups = getFormulationIngredients(state);

  return (
    <div className="quiz-section formulation-screen">
      <div className="quiz-section-inner">
        <div className="form-label-wrapper text-center">
          <h3 className="form-label">{parseTags(heading, state)}</h3>
          {!!subHeading && <p>{subHeading}</p>}
        </div>
        <div className="formulation-fields-wrapper">
          <FieldComponent
            defaultValue={state[normaliseKey(name)] || ''}
            ingredientGroups={ingredientGroups}
            rules={Array.isArray(rules) && useRules(rules, state)}
            name={name}
            autoSubmit={autoSubmit}
            onNext={onNext}
            {...props}
          />
        </div>
      </div>
    </div>
  );
};

FormulationScreen.propTypes = {
  state: PropTypes.shape().isRequired,
  step: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    subHeading: PropTypes.string,
    info: PropTypes.shape({
      title: PropTypes.string,
      description: PropTypes.string,
    }),
    autoSubmit: PropTypes.bool,
    field: PropTypes.shape({
      name: PropTypes.string,
      component: PropTypes.elementType.isRequired,
    }),
  }).isRequired,
  onNext: PropTypes.func.isRequired,
};

export default FormulationScreen;
